import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ClickAwayListener from '@mui/core/ClickAwayListener';
import { TwitterPicker } from 'react-color';

interface ColorPickerProps {
  label?: string;
  color?: string;
  onChange?: (color: string) => void;
}

export const ColorPicker = ({ label, color = '#000000', onChange = () => {} }: ColorPickerProps) => {
  const [visibleColorPicker, setVisibleColorPicker] = useState<boolean>(false);

  return (
    <Box>
      {label && (
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
      )}

      <ClickAwayListener onClickAway={() => setVisibleColorPicker(false)}>
        <Box>
          <Button
            variant="outlined"
            onClick={() => setVisibleColorPicker(!visibleColorPicker)}
            sx={{ width: 140, paddingX: 2 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
              <Box sx={{ width: 16, height: 16, bgcolor: color, borderRadius: 0.5, marginRight: 1.5 }} />
              <Typography color="textSecondary">{color}</Typography>
            </Box>
          </Button>

          <Box
            sx={{
              display: visibleColorPicker ? 'block' : 'none',
              position: 'absolute',
              zIndex: 1,
              marginTop: 0.5,
              marginLeft: 0.4,
            }}
          >
            <TwitterPicker
              color={color}
              onChangeComplete={(color) => {
                onChange(color.hex);
              }}
            />
          </Box>
        </Box>
      </ClickAwayListener>
    </Box>
  );
};
